"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataEmptyImage = void 0;
var React = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const DataEmptyImage = () => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  width: "140",
  height: "140",
  viewBox: "0 0 140 140",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M70.0001 120C97.551 120 120 97.5815 120 70.0465C119.907 42.4186 97.551 20 70.0001 20C42.3563 20 20 42.4186 20 69.9535C20 97.5815 42.3563 120 70.0001 120Z",
    fill: "#E6E5EF"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M125 78.2962C125 89.187 116.158 97.9944 105.13 97.9944C104.939 97.9944 103.323 97.9944 91.439 97.9944C83.1676 97.9944 69.9525 97.9944 48.8462 97.9944H38.7684C25.5532 98.2785 15 87.7665 15 75.0763C15 62.2915 25.6482 51.6848 39.0536 52.3477C50.5575 16.5501 103.228 21.5693 107.697 58.5981C117.584 59.8292 125 68.163 125 78.2962Z",
    fill: "white",
    stroke: "#D3D2E0",
    strokeWidth: "1.89405",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("mask", {
    id: "path-3-inside-1_1602_9728",
    fill: "white",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M107.411 58.6928C106.651 58.5981 105.89 58.5981 105.13 58.5981C101.232 58.5981 97.5237 59.7346 94.3862 61.7233"
    })
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M107.411 58.6928C106.651 58.5981 105.89 58.5981 105.13 58.5981C101.232 58.5981 97.5237 59.7346 94.3862 61.7233",
    fill: "white"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M107.528 57.7531C106.7 57.6499 105.881 57.6511 105.13 57.6511V59.5452C105.9 59.5452 106.602 59.5464 107.294 59.6326L107.528 57.7531ZM105.13 57.6511C101.046 57.6511 97.1635 58.8416 93.8792 60.9235L94.8933 62.5232C97.8838 60.6275 101.417 59.5452 105.13 59.5452V57.6511Z",
    fill: "#D3D2E0",
    mask: "url(#path-3-inside-1_1602_9728)"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M107.411 58.6928C106.651 58.5981 105.89 58.5981 105.13 58.5981C101.232 58.5981 97.5237 59.7346 94.3862 61.7233",
    stroke: "#D3D2E0",
    strokeWidth: "1.89405",
    strokeMiterlimit: "10",
    strokeLinecap: "round"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("mask", {
    id: "path-6-inside-2_1602_9728",
    fill: "white",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M39.0536 52.3477C37.9127 55.757 37.3423 59.3557 37.3423 63.1438C37.3423 64.659 37.4374 66.0795 37.6275 67.5001"
    })
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M39.0536 52.3477C37.9127 55.757 37.3423 59.3557 37.3423 63.1438C37.3423 64.659 37.4374 66.0795 37.6275 67.5001",
    fill: "white"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M38.1555 52.0471C36.9805 55.5584 36.3953 59.259 36.3953 63.1438H38.2893C38.2893 59.4523 38.8449 55.9555 39.9517 52.6482L38.1555 52.0471ZM36.3953 63.1438C36.3953 64.7 36.493 66.1625 36.6889 67.6257L38.5662 67.3744C38.3817 65.9965 38.2893 64.618 38.2893 63.1438H36.3953Z",
    fill: "#D3D2E0",
    mask: "url(#path-6-inside-2_1602_9728)"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M39.0536 52.3477C37.9127 55.757 37.3423 59.3557 37.3423 63.1438C37.3423 64.659 37.4374 66.0795 37.6275 67.5001",
    stroke: "#D3D2E0",
    strokeWidth: "1.89405",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M60.3602 74.589C61.8573 74.589 63.124 73.3273 63.124 71.836C63.124 70.3448 61.8573 69.083 60.3602 69.083C58.8632 69.083 57.5964 70.3448 57.5964 71.836C57.5964 73.3273 58.8632 74.589 60.3602 74.589Z",
    fill: "#66658D"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M81.5494 74.589C83.0468 74.589 84.3132 73.3273 84.3132 71.836C84.3132 70.3448 83.0468 69.083 81.5494 69.083C80.0524 69.083 78.7856 70.3448 78.7856 71.836C78.7856 73.442 80.0524 74.589 81.5494 74.589Z",
    fill: "#66658D"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M60.4301 64.0498L55.1844 66.8711L54.8151 66.1898L60.0608 63.3685L60.4301 64.0498Z",
    fill: "#66658D",
    stroke: "#D3D2E0",
    strokeWidth: "0.947027"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M86.6112 66.1455L86.2419 66.827L80.9958 64.0063L81.3653 63.3247L86.6112 66.1455Z",
    fill: "#66658D",
    stroke: "#D3D2E0",
    strokeWidth: "0.947027"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M70.9549 81.0126C72.7357 81.0126 74.1794 79.9342 74.1794 78.6038C74.1794 77.2734 72.7357 76.1948 70.9549 76.1948C69.1741 76.1948 67.7305 77.2734 67.7305 78.6038C67.7305 79.9342 69.1741 81.0126 70.9549 81.0126Z",
    fill: "#66658D"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M17.8137 19.4949C17.8137 19.4949 7.32981 22.1567 10.5068 24.2862C13.6837 26.3091 21.2025 29.8227 28.2976 27.4803C35.3928 25.1379 28.2976 21.8373 28.4035 21.8373C28.5094 21.8373 17.8137 19.4949 17.8137 19.4949Z",
    fill: "#E6E5EF",
    stroke: "#D3D2E0",
    strokeWidth: "1.5",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M5 18.6431C8.81233 19.8143 20.567 17.8978 28.0858 13C34.0161 20.3467 36.2399 22.2632 38.3579 22.4761C35.075 25.7768 24.1676 31.1004 18.0254 24.1797C10.8244 28.758 5 18.6431 5 18.6431Z",
    fill: "white",
    stroke: "#D3D2E0",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinejoin: "round"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M105 39.2861C109.024 39.4991 119.932 34.6013 125.862 28C133.487 33.6431 136.028 34.9207 138.252 34.6013C135.817 38.6473 128.404 47.4846 117.919 48.1234C110.295 43.6515 105 39.2861 105 39.2861Z",
    fill: "white",
    stroke: "#D3D2E0",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinejoin: "round"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M92.127 133.037C91.3308 129.087 83.8704 119.743 76 115.644C79.5659 106.854 80.1702 104.074 79.3069 102C83.8321 103.351 94.2373 108.329 97.4675 118.323C95.0359 126.821 92.127 133.037 92.127 133.037Z",
    fill: "white",
    stroke: "#D3D2E0",
    strokeWidth: "1.5",
    strokeMiterlimit: "10",
    strokeLinejoin: "round"
  })]
});
exports.DataEmptyImage = DataEmptyImage;